import React, { useEffect, useRef } from 'react';
import { Textarea as ChakraTextarea, TextareaProps } from '@chakra-ui/react';

export const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>((props, ref) => {
  const innerRef = useRef<HTMLTextAreaElement | null>(null);

  const createReactEventFromDOMEvent = (e: FocusEvent): React.FocusEvent<HTMLTextAreaElement> => {
    return {
      ...e,
      target: innerRef.current,
      currentTarget: innerRef.current,
      relatedTarget: e.relatedTarget,
      bubbles: e.bubbles,
      cancelable: e.cancelable,
      defaultPrevented: e.defaultPrevented,
      eventPhase: e.eventPhase,
      isTrusted: e.isTrusted,
      nativeEvent: e,
      preventDefault() {
        e.preventDefault();
      },
      isDefaultPrevented() {
        return e.defaultPrevented;
      },
      stopPropagation() {
        e.stopPropagation();
      },
      isPropagationStopped() {
        return e.cancelBubble;
      },
      persist() {},
      timeStamp: e.timeStamp,
      type: e.type,
    } as React.FocusEvent<HTMLTextAreaElement>;
  };

  useEffect(() => {
    const handleBlur = (e: FocusEvent) => {
      const reactEvent = createReactEventFromDOMEvent(e);

      props.onBlur?.(reactEvent);
    };

    // Unfortunately, react onBlur doesn't trigger when user closes the virtual keyboard on iOS
    // Use DOM event as a supplement
    innerRef.current?.addEventListener('blur', handleBlur);
    return () => {
      innerRef.current?.removeEventListener('blur', handleBlur);
    };
  }, []);

  const setRef = (element: HTMLTextAreaElement | null) => {
    if (typeof ref === 'function') {
      ref(element);
    } else if (ref) {
      ref.current = element;
    }

    innerRef.current = element;
  };

  return <ChakraTextarea {...props} ref={setRef} />;
});
